import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
    type: { default: "text" },
    maxWidth: null,
    fullHeight: { type: Boolean },
    height: null
  },
  setup(__props: any) {

const props = __props as { type: string, maxWidth?: string, fullHeight?: boolean, height?: string };



const skeletonClasses = computed(() => {
  return {
    'skeleton-loader--full-height': props.fullHeight,
    [`${props.type}`]: true
  }
})

return { __sfc: true,props, skeletonClasses }
}

})